"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var keyboard = require("../../_Core/Keyboard");
var Icons_1 = require("../../Icons");
var Loader_1 = require("../../Indicators/Loader");
var Localization_1 = require("../../Localization");
var TileBase_styles_1 = require("../TileBase/TileBase.styles");
var TabbedTile_styles_1 = require("./TabbedTile.styles");
exports.default = (function (_a) {
    var Tabs = _a.Tabs, Loading = _a.Loading;
    var _b = React.useState(-1), hoveringIndex = _b[0], setHoveringIndex = _b[1];
    var _c = React.useState(0), currentIndex = _c[0], setCurrentIndex = _c[1];
    var barRef = React.createRef();
    var tabList = React.createRef();
    var handleKeyDown = function (e) {
        var tabs = tabList.current.querySelectorAll('[role="tab"]');
        var newTabIndex;
        if (!keyboard.IsLeftArrow(e) && !keyboard.IsRightArrow(e)) {
            return;
        }
        if (keyboard.IsRightArrow(e)) {
            newTabIndex = currentIndex + 1;
        }
        else if (keyboard.IsLeftArrow(e)) {
            newTabIndex = currentIndex - 1;
        }
        if (newTabIndex < 0) {
            newTabIndex = Tabs.length - 1;
        }
        else if (newTabIndex >= Tabs.length) {
            newTabIndex = 0;
        }
        setCurrentIndex(newTabIndex);
        tabs[newTabIndex].focus();
    };
    React.useEffect(function () {
        if (tabList.current) {
            var box = tabList.current.children[currentIndex];
            barRef.current.style.transform = "translate3d(" + box.offsetLeft + "px, 0, 0)";
            barRef.current.style.width = box.offsetWidth + "px";
        }
    }, [currentIndex, Loading]);
    return (React.createElement(TabbedTile_styles_1.TabbedSection, null,
        React.createElement(TabbedTile_styles_1.Nav, null,
            !Loading && (React.createElement(TabbedTile_styles_1.UL, { role: "tablist", ref: tabList }, Tabs.map(function (tab, index) {
                var handleClick = function () {
                    setCurrentIndex(index);
                };
                return (React.createElement(TabbedTile_styles_1.LI, { key: tab.Id, role: "presentation" },
                    React.createElement(TabbedTile_styles_1.Button, { type: "button", role: "tab", "aria-selected": index === currentIndex, id: tab.Id, "aria-controls": tab.TabPanelId, onClick: handleClick, onMouseEnter: function () { return setHoveringIndex(index); }, onMouseLeave: function () { return setHoveringIndex(-1); }, onKeyDown: handleKeyDown, tabIndex: index === currentIndex ? 0 : -1 },
                        tab.Icon && (React.createElement(TabbedTile_styles_1.IconWrapperDiv, { Color: tab.IconColor },
                            React.createElement(Icons_1.Icon, { Icon: tab.Icon }))),
                        React.createElement(TabbedTile_styles_1.CaptionSpan, { Hover: index === hoveringIndex }, tab.Caption))));
            }))),
            React.createElement(TabbedTile_styles_1.BarDiv, { ref: barRef, Width: "auto" })),
        React.createElement(TileBase_styles_1.Line, null),
        Loading ? (React.createElement(Loader_1.AreaLoader, { Caption: Localization_1.strings.Label_Loading })) : (React.createElement(TabbedTile_styles_1.AnimationDiv, { key: Tabs[currentIndex].Id },
            React.createElement(TabbedTile_styles_1.TabPanelDiv, { id: Tabs[currentIndex].TabPanelId, role: "tabpanel", "aria-labelledby": Tabs[currentIndex].Id, tabIndex: 0 }, Tabs[currentIndex].TabArticleButtonsAndFooter())))));
});
